// @flow

import * as React from 'react';
import {ContentGroupItem} from 'docs/util';
import {TabGroup} from '../Tabs/TabGroup';

type BeforeAfterTableGroupProps = {|
  items: Array<ContentGroupItem>,
  pref?: string,
|};

export const BeforeAfterTableGroup = (props: BeforeAfterTableGroupProps) => {
  return <TabGroup selector="tabs" {...props} />;
};
